import ASSETS from '@generio-ai/library-legacy/constants/assets'
import CARD from '@/constants/card.js'
import { Card } from '@/classes/card.js'
import { Prompt } from '@/classes/prompt.js'

export const AGENT_WAITING = 'Waiting for available agent'

export function nextAgentIndex(cards) {
    return cards.reduce((index, card) => Math.max(index, card.index + 1), 0)
}

export function normalizeAgentStatus(response) {
    const raw = String(typeof response === 'string' ? response : response?.status || '')
    const separator = raw.indexOf(':')
    const state = (separator < 0 ? raw : raw.slice(0, separator)).trim().toLowerCase()
    const details = separator < 0 ? response?.details : raw.slice(separator + 1)
    const message = typeof details === 'string' ? details.trim() : ''
    if (!['pending', 'ready', 'error'].includes(state)) throw new Error('Unrecognized agent status.')
    return { state, message: message || (state === 'pending' ? AGENT_WAITING : '') }
}

export function agentError(message, uncertain = false) {
    return Object.assign(new Error(message), { uncertain })
}

export function restoreAgentCards(assets, flowId) {
    const groups = new Map()
    for (const asset of assets) {
        const index = asset.additional?.card?.index
        if (!Number.isInteger(index)) continue
        if (!groups.has(index)) groups.set(index, [])
        groups.get(index).push(asset)
    }
    return [...groups.entries()].sort(([a], [b]) => a - b).map(([index, group]) => {
        const asset = group[0]
        const additional = asset.additional
        const card = new Card(flowId, index, additional.card.component, additional.category, Prompt.newPromptFromAsset(asset))
        card.assets = group.sort((a, b) => (a.additional?.custom?.agent?.imageIndex || 0) - (b.additional?.custom?.agent?.imageIndex || 0))
        // Do not share the mutable runtime state with persisted metadata.
        card.custom = { ...additional.custom, agent: { ...additional.custom?.agent } }
        card.primitive = additional.primitive === true
        return card
    })
}

export function agentMessages(cards, getAsset) {
    return cards.filter(card => card.assets?.length || card.custom?.agent?.state).map(card => {
        const assets = (card.assets || []).map(asset => getAsset(asset.id) || asset)
        const info = card.custom?.agent || {}
        if (card.component === CARD.AGENT_INPUT) {
            return {
                id: card.index,
                role: 'user',
                text: card.prompt.user,
                attachments: assets.filter(asset => asset.type === ASSETS.TYPES.IMAGE).map((asset, index) => ({
                    id: asset.id,
                    name: asset.additional?.custom?.agent?.name || `Reference ${index + 1}`,
                    preview: asset.files?.default?.data || asset.thumbnail?.data || card.localAttachments?.[index]?.preview
                })).concat((card.localAttachments || []).slice(assets.length))
            }
        }
        return {
            id: card.index,
            role: 'agent',
            inputId: info.inputIndex,
            asset: assets[0] || null,
            state: info.state || 'pending',
            status: info.status || AGENT_WAITING,
            error: info.error || '',
            pending: ['committing', 'requesting', 'pending', 'reconnecting'].includes(info.state),
            uncertain: info.state === 'uncertain'
        }
    })
}

